import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoadingState } from '../components/ui';
import { useAuth } from './useAuth';

/**
 * Client-side routing guard.
 *
 * This is a convenience, not a security boundary: it keeps signed-out visitors
 * from staring at an empty page. The backend refuses the data regardless
 * (Rule 7).
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { account, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LoadingState label="Checking your session…" />;
  }

  if (!account) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
